<template>
  <div class="lazada_edit">
    <Breadcrumb style="width: 90%"></Breadcrumb>
    <!--按钮组-->
    <div style="text-align: right;margin-top: 15px;width: 90%">
      <el-button type="info" size="small">一键翻译</el-button>
      <el-button type="warning" size="small" @click="saveEditPro">保存</el-button>
      <el-button type="primary" size="small" @click="submitForm">保存并移入待发布</el-button>
    </div>

    <div id="main" style="width: 90%">
      <el-form :model="firstForm" :rules="rules" ref="firstForm" label-width="150px">
        <div id="p1" class="t_plane self_el_item_form">
          <div class="pl_til">平台定制信息（注：下列信息，仅在此平台定制系统生效）</div>
          <div class="pl_content">
            <el-form-item label="平台定制分类:">
              <TreeSelect :props="props" :options="treeList" v-model="firstForm.typeNo" ref="childSelTree"
                          style="width: 50%;margin-right: 10px" @getValue="getTreeNodeId"></TreeSelect>

            </el-form-item>
              <el-form-item label="来源URL:" id="url_ly">
                  <template v-for="(item,index) in firstForm.urls" >
                      <el-input :key="'url_4_' + index" size="small" v-model="item.url" style="width:50%;margin:0 5px 5px 0;">
                          <template slot="prepend" style="width: 20px;">{{index +1}}</template>
                          <el-button slot="append" @click="goUrl(item.url)">访问</el-button>
                      </el-input>
                      <a :key="'a_1' +index" class="url_a" @click="addUrl"><i class="el-icon-plus" v-show="index == 0 && urlSize < 5"></i></a>
                      <a :key="'a_2' +index" class="url_a" @click="deleteUrl(index)"><i class="el-icon-minus" v-if="index > 0"></i></a>
                  </template>
              </el-form-item>

          </div>
        </div>
        <div class="t_plane self_el_item_form" id="baseInfo">
          <div class="pl_til">基本信息</div>
          <div class="pl_content">
            <el-form-item label="店铺:" prop="shopId">
              <el-select clearable  v-model="firstForm.shopId" placeholder="---请选择店铺---" size="small" style="width:50%" clearable>
                <el-option
                    v-for="item in claimList"
                    :key="item.shopId"
                    :label="item.shopName"
                    :value="item.shopId">{{item.shopName}}({{dictData['amazon_site'][item.amazonSite]}})
                </el-option>
              </el-select>
              <div class="item_bot">
                <span style="padding-right: 10px;">同步发布到其他站点:</span>
                <template>
                  <el-checkbox style="padding-right: 10px;" :indeterminate="isIndeterminate" v-model="checkAll"
                               @change="handleCheckAllChange">全选
                  </el-checkbox>
                  <el-checkbox-group style="width: 75%;float: right;" v-model="firstForm.fbzd"
                                     @change="handleCheckedCitiesChange">
                    <el-checkbox v-for="(zd,index) in zdList" :key="'fb_' + index" :label="zd">{{ zd }}</el-checkbox>
                  </el-checkbox-group>
                </template>
              </div>

            </el-form-item>
            <el-form-item label="产品分类:" prop="shopTypeProp">
              <el-input v-model="firstForm.shopType" placeholder="请选择内容" style="width: 300px" size="small"></el-input>
              <el-button type="primary" style="margin-left: 15px" size="small" @click="getPlatTypeTree">选择分类</el-button>
              <el-row style="color: red;font-size: 12px">
                <span>{{ cascaderName }}</span>
              </el-row>
            </el-form-item>

          </div>
        </div>
        <div class="t_plane self_el_item_form" id="proInfo">
          <div class="pl_til">产品信息</div>
          <div class="pl_content">
            <el-form-item prop="proTitle" label="产品标题">
              <el-input size="small" v-model="firstForm.proTitle" style="width:50%"></el-input>
            </el-form-item>
            <el-form-item prop="maProTitle" label="产品标题(马来语)">
              <el-input size="small" v-model="firstForm.maProTitle" style="width:50%"></el-input>
            </el-form-item>
            <el-form-item label="品牌">
              <el-input size="small" v-model="firstForm.brand" style="width:50%"></el-input>
            </el-form-item>
            <el-form-item label="型号">
              <el-input size="small" v-model="firstForm.model" style="width:50%"></el-input>
            </el-form-item>
            <el-form-item label="质保类型">
              <el-select clearable  v-model="firstForm.quaType" size="small" style="width:50%">
                <el-option
                    v-for="item in quaTypeList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="关键属性" label-width="150px">
              <el-collapse class="import-prop heigt-90"
                  style="background-color: #EEEEEE;width: 80%;padding-top: 20px;text-align: left;position: relative;overflow: hidden">
                <el-form-item label="Material(材料过滤器):" prop="material" label-width="250px">
                  <el-select clearable  v-model="firstForm.material" placeholder="请选择" style="width: 300px" size="small">
                    <el-option
                        v-for="item in material"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Pattern( fa_pattern):" prop="pattern" label-width="250px">
                  <el-select clearable  v-model="firstForm.pattern" placeholder="请选择" style="width: 300px" size="small">
                    <el-option
                        v-for="item in pattern"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Warranty Period:" prop="warrantyPeriod" label-width="250px">
                  <el-select clearable  v-model="firstForm.warrantyPeriod" placeholder="请选择" style="width: 300px" size="small">
                    <el-option
                        v-for="item in warrantyPeriod"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Warranty Policy:" prop="warrantyPolicy" label-width="250px">
                  <el-input size="small" v-model="firstForm.warrantyPolicy" style="width: 300px" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item label="Delivery Option Express:" prop="deliveryOptionExpress" label-width="250px">
                  <el-select clearable  v-model="firstForm.deliveryOptionExpress" placeholder="请选择" style="width: 300px"
                             size="small">
                    <el-option
                        v-for="item in deliveryOptionExpress"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="fa_create_year:" prop="fa_create_year" label-width="250px">
                  <el-select clearable  v-model="firstForm.fa_create_year" placeholder="请选择" style="width: 300px" size="small">
                    <el-option
                        v-for="item in fa_create_year"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="fa_season:" prop="fa_season" label-width="250px">
                  <el-select clearable  v-model="firstForm.fa_season" placeholder="请选择" style="width: 300px" size="small">
                    <el-option
                        v-for="item in fa_season"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Delivery Option Economy:" prop="deliveryOptionEconomy" label-width="250px">
                  <el-select clearable  v-model="firstForm.deliveryOptionEconomy" placeholder="请选择" style="width: 300px"
                             size="small">
                    <el-option
                        v-for="item in deliveryOptionEconomy"
                        :key="item.dictValue"
                        :label="item.dictLabel"
                        :value="item.dictCode">
                    </el-option>
                  </el-select>
                </el-form-item>
                <div></div>
                <el-form-item label="Dangerous Goods:" label-width="250px">
                  <el-radio-group v-model="firstForm.DangerousGoods" class="hide_input">
                    <el-radio label="all">全部</el-radio>
                    <el-radio v-for="(item,index) in DangerousGoods" :label="item.dictCode">{{ item.dictLabel }}
                    </el-radio>
                  </el-radio-group>
                </el-form-item>

                <el-form-item label="Warranty Policy (English):" prop="warrantyPolicy" label-width="250px">
                  <el-input size="small" v-model="firstForm.warrantyPolicy" style="width: 300px" placeholder="请输入">
                  </el-input>
                </el-form-item>

                <el-form-item label="Product Description (Malay):" prop="ProductDescription" label-width="250px">
                  <CKEditor4 v-model="firstForm.simDesc" :config="editorConfig_2"></CKEditor4>
                </el-form-item>
              <div style="position: absolute;right: 5px;bottom:0"><el-button type="text" size="mini" @click="showMoreProp">{{expendBtnText}}</el-button></div>
              </el-collapse>
            </el-form-item>

          </div>
        </div>
        <div class="t_plane self_el_item_form">
          <div class="pl_til">包装信息</div>
          <div class="pl_content">
            <el-form-item label="税" prop="tax">
              <el-select clearable  v-model="firstForm.tax" size="small" style="width:50%" clearable>
                <el-option
                    v-for="item in taxList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictLabel">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="包装重量" prop="packWeight">
              <el-input size="small" v-model.trim="firstForm.packWeight" style="width:50%" placeholder="请输入包装重量">
                <template slot="append">kg</template>
              </el-input>
            </el-form-item>
            <el-form-item label="包装体积">
              <div style="width: 50%;display: flex;">
                <el-col :span="8">
                  <el-form-item prop="packLong">
                    <el-input size="small" v-model.number="firstForm.packLong" placeholder="请输入长度">
                      <template slot="append">cm</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="packWide">
                    <el-input size="small" v-model.number="firstForm.packWide" placeholder="请输入宽度">
                      <template slot="append">cm</template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item prop="packHigh">
                    <el-input size="small" v-model.number="firstForm.packHigh" placeholder="请输入高度">
                      <template slot="append">cm</template>
                    </el-input>
                  </el-form-item>
                </el-col>
              </div>
            </el-form-item>
            <el-form-item label="包装内容" prop="packContent">
              <el-input v-model="firstForm.packContent" type="textarea" show-word-limit style="width:50%"></el-input>
            </el-form-item>
          </div>
        </div>
        <div class="t_plane self_el_item_form">
          <div class="pl_til">变种参数</div>
          <div class="pl_listOut">
            <el-form-item label="Color family" prop="c_checkList">
              <el-row style="max-height: 400px">
                <el-col :span="4" class="span_4">
                <el-input class="filter_input" size="small" v-model="colorFilteField" @input="c_fieldChange"
                          suffix-icon="el-icon-search" placeholder="请输入过滤字段"></el-input>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <el-checkbox-group v-model="firstForm.c_checkList" id="col_List" @change="changeCheckColor">
                    <template v-for="(item,index) in colorList">
                      <el-checkbox :key="item.dictCode" :label="item.dictLabel" style="height: 20px;line-height: 20px" >
                        <div v-show="!item.isEdit">
                          <span>{{item.dictLabel}}</span>
                          <a class="color-a-edit" v-if="item.hasOwnProperty('isManualAdd')" href="javascript:void(0)" @click="editColorName(item)"> <i class="el-icon-edit" /></a>
                        </div>
                        <div v-show="item.isEdit">
                          <el-input class="color-radio-input" size="mini" v-model="item.dictLabel"></el-input>
                          <a class="color-a-save" href="javascript:void(0)" @click="saveEditColorName(item)"><svg-icon icon-class="save" /></a>
                          <a class="color-a-cancle" href="javascript:void(0)" @click="cancleEditColorName(item)" :id="item.dictLabel"><svg-icon icon-class="cancle" /></a>
                        </div>
                      </el-checkbox>
                    </template>
                  </el-checkbox-group>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="其他">
              <el-input size="small" style="width: 20%;margin-right: 10px" v-model.trim="otherColor"></el-input>
              <el-button size="small" type="primary" @click="addColor" :disabled="otherColor == '' || otherColor == null">添加</el-button>
            </el-form-item>
          </div>
          <div class="pl_listOut">
            <el-form-item label="Body Clothing Size" prop="sizes">
              <el-row>
                <el-col :span="4" class="span_4">
                  <el-input size="small" v-model="sizeFilteField" @input="s_fieldChange" suffix-icon="el-icon-search"
                            placeholder="请输入过滤字段"></el-input>
                </el-col>
              </el-row>
              <el-row style="max-height: 400px">
                <el-col :span="24">
                  <el-checkbox-group v-model="firstForm.s_checkList" id="siz_List" @change="changeCheckSize">
                    <template v-for="(item,index) in sizeList">
                      <el-checkbox :key="item.dictCode" :label="item.dictLabel" style="height: 20px;line-height: 20px"></el-checkbox>
                    </template>
                  </el-checkbox-group>
                </el-col>
              </el-row>
            </el-form-item>
<!--            <el-form-item label="其他">-->
<!--              <el-input size="small" style="width: 20%;margin-right: 10px" v-model.trim="otherSize"></el-input>-->
<!--              <el-button size="small" type="primary" @click="addSize" :disabled="otherSize == ''|| otherSize == null">添加</el-button>-->
<!--            </el-form-item>-->
          </div>
        </div>
        <div class="t_plane self_el_item_form">
          <div class="pl_til">自定义缩略图</div>
          <div class="thumbnails-box">
            <div class="thumbnails-single" v-for="(item,index) in firstForm.c_checkList">
              <div class="color-name">{{item}}</div>
<!--              <img class="colorImg" src="../../../assets/images/addImg.jpg">-->
              <el-upload :class="'upload_img_'+index" action="#" list-type="picture-card" style="text-align: center;width: 108px;height: 104px" accept=".jpg,.png"
                         :on-remove="(file, fileList) => zdyImgRemove(file, fileList,index)"
                         :on-change="(file, fileList) => zdyImgChange(file, fileList,index)"
                         :on-success="(file, fileList) => zdyImgSuccess(file, fileList,index)"
                         :http-request="uploadZdyImg">
                <img :id="'default_img_'+index" class="colorImg" src="../../../assets/images/addImg.jpg">
              </el-upload>

            </div>
          </div>

        </div>

        <div class="t_plane self_el_item_form" style="padding-bottom: 10px;">
          <div class="pl_til">变种信息</div>
          <div style="background-color: white;text-align: center;margin: 10px 10px 0px 10px;">
            <el-container>
              <!--表格-->
              <div style="margin-top: 2px;width: 100%">
                <el-form :model="bzxx" ref="bzxx" :rules="bzxxRules">
                  <el-table border :data="bzxx.tableData" style="width: 100%" class="bz-info-tab">
                  <el-table-column prop="skuno" align="center" width="160">
                    <template slot="header" slot-scope="scope">
                      <el-row>
                        <span style="color: red">*</span>SKU<br/>
                        <a href="javascript:void(0)" @click="creatSkuRuleVisible = true" style="color: #029ef3;text-decoration: none">(一键生成)</a>
                      </el-row>
                    </template>
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.skuno'" :rules="bzxxRules.skuno">
                        <el-input size="mini" v-model="scope.row.skuno"/>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column prop="colorName" align="center" width="130">
                    <template slot="header" slot-scope="scope">
                      <el-row>Color Family</el-row>
                    </template>
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.colorName'">
                        <el-input size="mini" v-model="scope.row.colorName"/>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column prop="sizeName" align="center" width="120">
                    <template slot="header" slot-scope="scope">
                      <el-row>Size</el-row>
                    </template>
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.sizeName'">
                        <el-input size="mini" v-model="scope.row.sizeName"/>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column prop="kuCun" align="center" width="120">
                    <template slot="header" slot-scope="scope">
                      <el-row>
                        <span style="color: red">*</span>库存<br/>
                        <a href="javascript:void(0)" @click="updateSkuInventVisible = true" style="color: #029ef3;text-decoration: none">(批量)</a>
                      </el-row>
                      <!--<el-row style="color: #029ef3;" >(批量)</el-row>-->
                    </template>
                    <template slot-scope="scope">
                      <el-form-item :prop="'tableData.' + scope.$index + '.invent'" :rules="bzxxRules.invent">
                        <el-input onkeyup="value=value.replace(/[^0-9]/g,'').replace(/^0{2}/g,'')" size="mini" v-model="scope.row.invent"/>
                      </el-form-item>
                    </template>
                  </el-table-column>

                  <el-table-column prop="price" align="center" width="130">
                    <template slot="header" slot-scope="scope">
                      <span style="color: red">*</span>价格<br/>
                      <a href="javascript:void(0)" @click="openPriceDialog('价格')" style="color: #029ef3;text-decoration: none">(批量)</a>
                    </template>
                    <template slot-scope="scope">
                      <el-row>
                        <el-col :span="18">
                          <el-form-item :prop="'tableData.' + scope.$index + '.price'" :rules="bzxxRules.price">
                            <el-input onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d{1,9}(\.?\d{0,2})/g);" size="mini" v-model="scope.row.price" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="6" style="font-size: 12px">MYR</el-col>
                      </el-row>
                      <el-row style="text-align: left;color:#999;font-size: 12px" v-if="scope.row.price != null && scope.row.price != ''" v-show="false">
<!--                    https://api.exchangerate-api.com/v4/latest/MYR-->
<!--                        汇率接口-->
                          <span>≈ </span> <span>1.41</span><span>USD</span>
                      </el-row>
                    </template>
                  </el-table-column>

                  <el-table-column prop="promotePrice" align="center" width="130">
                    <template slot="header" slot-scope="scope">
                      促销价<br/>
                      <a href="javascript:void(0)" @click="openPriceDialog('促销价')" style="color: #029ef3;text-decoration: none">(批量)</a>
                    </template>
                    <template slot-scope="scope">
                      <el-row>
                        <el-col :span="18">
                          <el-input size="mini" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d{1,9}(\.?\d{0,2})/g);" v-model="scope.row.promPrice"/>
                        </el-col>
                        <el-col :span="6" style="font-size: 12px">MYR</el-col>
                      </el-row>
                      <el-row style="text-align: left;color:#999;font-size: 12px" v-if="scope.row.promPrice != null && scope.row.promPrice != ''" v-show="false">
                        <!--                    https://api.exchangerate-api.com/v4/latest/MYR-->
                        <!--                        汇率接口-->
                        <span>≈ </span> <span>1.41</span><span>USD</span>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" align="center" width="300">
                    <template slot="header" slot-scope="scope">
                      促销时间<br/>
                      <a href="javascript:void(0)" @click="updateSkuTimeVisible = true"  style="color: #029ef3;text-decoration: none">(批量)</a>
                    </template>
                    <template slot-scope="scope">
                      <el-row class="lazada_date">
                        <el-col :span="12">
                          <el-date-picker size="small" class="date_socpe" v-model="scope.row.startTime" align="right" type="date" placeholder="开始日期" :picker-options="skuTimeOption"></el-date-picker>
                        </el-col>
                        <el-col :span="12">
                          <el-date-picker size="small" class="date_socpe" v-model="scope.row.stopTime" align="right" type="date" placeholder="结束日期" :picker-options="tabSkuEndTimeOption" @focus="setCurrentSku(scope.row.startTime)" :disabled="scope.row.startTime == null"></el-date-picker>
                        </el-col>
                      </el-row>
                    </template>
                  </el-table-column>
                  <el-table-column prop="name" align="center" width="100">
                    <template slot="header" slot-scope="scope">
                      <el-row>
                        更多<br/>
                        <a href="javascript:void(0)" @click="" style="color: #029ef3;text-decoration: none">(批量设置)</a>
                      </el-row>
                      <!-- <el-row style="color: #029ef3" >(批量设置)</el-row>-->
                    </template>
                    <template slot-scope="scope">
                      <el-button type="text" size="mini" @click="setAttr(scope.row)">设置</el-button>
                      <el-button type="text" size="mini" @click="moveAttr(scope.row,scope.$index)">移除</el-button>
                      <br/>
                    </template>
                  </el-table-column>
                </el-table>
                </el-form>
              </div>

            </el-container>
          </div>
        </div>

        <div class="t_plane self_el_item_form">
          <div class="pl_til">变种图片</div>
            <el-row style="font-size: 13px;margin: 10px 0">
              <el-col :span="4" style="text-align: center">变种图片:</el-col>
              <el-col :span="20" style="text-align: right;padding-right: 10px">
                <el-link type="primary" @click="batchAddWater">批量加水印</el-link>
                <span style="margin-left: 15px;margin-right: 15px;color: #029ef3">|</span>
                <el-link type="primary" @click="updatePicSize">改变图片大小</el-link>
                <span style="margin-left: 15px;margin-right: 15px;color: #029ef3">|</span>
                <el-link type="primary" @click="exportAllPic">导出全部图片</el-link>
              </el-col>
            </el-row>
            <el-row v-for="map in colorAndSizeGroup" style="margin-top: 15px">
              <el-col :span="22" style="float: right">
                <div style="display: flex;height: 36px;align-items: center;justify-content: space-between;color: #434649;">
                  <div>
                    <el-upload
                        class="upload-demo"
                        action="#"
                        :limit="8"
                        :file-list="map.picList"
                        :show-file-list="false"
                        :on-preview="handlePreview"
                        :on-remove="handleRemove"
                        :before-remove="beforeRemove"
                        :http-request="data => requertUpload(data,map.picList)"
                        multiple
                        :on-exceed="files=>handleExceed(files,map.picList)">
                      <el-button size="small" type="info" plain>点击上传</el-button>
                    </el-upload>
                  </div>
                  <div style="font-size: 13px;width: 350px;height: 100%">
                    <div v-if="map.hasOwnProperty('color')">color_family:{{map.color}}</div>
                    <div v-if="map.hasOwnProperty('size')">size:{{map.size}}</div>
                  </div>
                  <div>
                      <span style="font-size: 13px">【{{map.picList.length}}/8】图片</span>
                  </div>
                  <div>
                    <el-button size="small" type="primary">引用采集图片</el-button>
                    <el-dropdown style="margin:0 20px 0 10px">
                      <el-button size="small" type="primary">
                        图片应用到
                      </el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>所有变种</el-dropdown-item>
                        <el-dropdown-item>同size变种</el-dropdown-item>
                        <el-dropdown-item>同color_family变种</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div v-if="map.picList.length > 0"  class="bz_edit_img">
                    <draggable @start="start" @end="end" style="display: flex">
                      <div v-for="item in map.picList" class="c_s_img">
                          <img :src="item.img" :class="item.class" />
                          <span class="c_s_del">
                            <el-button type="text" icon="el-icon-delete" @click="removeBzImg(item,map.picList)"></el-button>
                          </span>
                      </div>
                    </draggable>
                </div>
                <div v-else class="default-div">
                  <img class="default-kong"  src="../../../assets/images/kong.png"/>
                </div>
              </el-col>
            </el-row>

        </div>

        <div class="t_plane">
          <div class="pl_til">描述信息</div>
          <div class="pl_content">
            <el-form-item label="产品描述" prop="detail">
              <span style="color: red">说明：描述区图片尺寸需小于5000x5000，图片大小不能超过3M!</span>
              <CKEditor4 v-model="firstForm.detail" :config="editorConfig_1"></CKEditor4>
            </el-form-item>
            <el-form-item label="短描述" prop="simDesc">
              <CKEditor4 v-model="firstForm.simDesc" :config="editorConfig_2"></CKEditor4>
            </el-form-item>
            <el-form-item label="视频URL" prop="playUrl">
              <el-input size="small" v-model="firstForm.playUrl"></el-input>
            </el-form-item>
          </div>
        </div>
        <div style="width:75%;text-align: right;margin: auto;;padding-top: 10px;">
          <div style="text-align: right;margin-top: 15px">
            <el-button type="info" size="small">一键翻译</el-button>
            <el-button type="warning" size="small">保存</el-button>
            <el-button type="primary" size="small">保存并移入待发布</el-button>
          </div>
        </div>

        <!--LAZADA平台类目-->
        <el-dialog :close-on-click-modal="false"  
            title="lazada平台类目"
            :visible.sync="lazadaDialogVisible"
            width="50%"
            center>
          <div class="block" style="height: 250px;padding: 10px">
            <span style="padding-right: 10px">搜索:</span>
            <el-cascader
                ref="cascaderAddr"
                v-model="platType"
                placeholder="试试搜索：指南"
                :options="lazadaOptions"
                @change="handleChange"
                filterable
                style="width: 80%" size="small"></el-cascader>
          </div>
          <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="lazadaDialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="lazadaDialogSubmit">确 定</el-button>
          </span>
        </el-dialog>

        <!--变种参数弹框-->
        <el-dialog :close-on-click-modal="false"  
            title="变种参数"
            :visible.sync="bzxxDialogVisible"
            width="733px"
            center>
          <div class="block" style="height: 200px">
            <el-form-item label="产品尺寸：" style="width: 60%;margin-bottom: 1px;" prop="proSize">
              <el-input size="small" v-model="firstForm.proSize"></el-input>
            </el-form-item>
            <el-form-item label="产品重量：" style="width: 60%;margin-bottom: 1px;" prop="proWeight">
              <el-input size="small" v-model="firstForm.proWeight"></el-input>
            </el-form-item>
            <el-form-item label="brarcode：" style="width: 60%;margin-bottom: 1px; " prop="proBrarcode">
              <el-input size="small" v-model="firstForm.proBrarcode"></el-input>
            </el-form-item>
            <el-form-item label="备注：" style="width: 60%;margin-bottom: 1px;" prop="proRemark">
              <el-input size="small" v-model="firstForm.proRemark"></el-input>
            </el-form-item>
          </div>
          <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="bzxxDialogSubmit">确 定</el-button>
                <el-button @click="bzxxDialogVisible = false">取 消</el-button>
            </span>
        </el-dialog>
      </el-form>
    </div>

    <ul id="LoutiNav" style="position: fixed;display: block;">
      <li><svg-icon icon-class="right-1"/><span>基本信息</span></li>
      <li><svg-icon icon-class="right-1"/><span>平台定制信息</span></li>
      <li><svg-icon icon-class="right-1"/><span>产品信息</span></li>
      <li><svg-icon icon-class="right-1"/><span>包装信息</span></li>
      <li><svg-icon icon-class="right-1"/><span>变种参数</span></li>
      <li><svg-icon icon-class="right-1"/><span>自定义缩略图</span></li>
      <li><svg-icon icon-class="right-1"/><span>变种信息</span></li>
      <li><svg-icon icon-class="right-1"/><span>变种图片</span></li>
      <li><svg-icon icon-class="right-1"/><span>描述信息</span></li>
    </ul>

    <!--        选择分类dialog-->
    <el-dialog :close-on-click-modal="false"   title="选择类目" :visible.sync="chooseType">
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="submitChooseType">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"   title="SKU生成规则" :visible.sync="creatSkuRuleVisible" width="500px">
        <el-form :model="skuRuleForm" label-width="80" style="margin: 10px 20px 0 20px">
            <el-form-item label="前缀:" style="margin-bottom: initial">
              <el-input style="width: 60%" size="small" v-model="skuRuleForm.prefix" placeholder="请输入前缀，如:MK"></el-input>
            </el-form-item>
            <el-form-item label="后缀:">
              <el-input style="width: 60%" size="small" v-model="skuRuleForm.suffix" placeholder="请输入后缀，如:SN"></el-input>
            </el-form-item>
          <span style="color: #999;font-size: 12px">SKU生成格式=[前缀]-[Variation]-[后缀]</span><br/>
          <span style="color: #999;font-size: 12px">例如:前缀=MK，Variation=XL，后缀=SN </span><br/>
          <span style="color: #999;font-size: 12px">生成：MK-XL-SN </span>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="creatSkuRuleVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="creatSkuBatch">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"   title="修改库存" :visible.sync="updateSkuInventVisible" width="500px">
      <div style="margin: 10px 20px 0 20px">
        <el-radio-group v-model="skuInventRadio">
          <el-radio :label="1">
            <el-input size="small" onkeyup="value=value.replace(/[^0-9]/g,'').replace(/^0{2}/g,'')" v-model="updateSkuInventNum_1" style="width: 200px" :disabled="skuInventRadio != 1"></el-input>
            <span style="color: #999;font-size: 12px">直接修改库存量</span>
          </el-radio>
          <div style="height: 10px"></div>
          <el-radio :label="2">
            <el-input size="small" @change="clearNoNumAndFloat"  onkeyup="this.value=this.value.replace(/^[^0-9-]/g, '').replace(/^\-{2}/g,'').replace(/^0{2}/g,'').match(/-?\d*/)"   v-model="updateSkuInventNum_2" style="width: 200px" :disabled="skuInventRadio != 2"></el-input>
            <span style="color: #999;font-size: 12px">根据库存量增减</span>
          </el-radio>
        </el-radio-group>
      <div><span style="color: #999;font-size: 12px">提示:根据库存量增减时,输入负数表示减少，正数表示增加。</span></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="updateSkuInventVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateSkuInvent">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :close-on-click-modal="false"   title="修改价格" :visible.sync="updateSkuPriceVisible" width="500px">
      <div style="margin: 10px 20px 0 20px;border: 1px solid #ccc">
        <el-row style="background-color: #eee;height: 35px;line-height: 35px;text-align: center;font-weight: 600;border-bottom: 1px solid #ccc">
          <el-col :span="10">站点</el-col>
          <el-col :span="14">{{priceText}}</el-col>
        </el-row>
        <el-row style="height: 35px;line-height: 35px;text-align: center">
          <el-col :span="10" style="border-right: 1px solid #ccc"><span style="color: red">*</span><span>默认</span></el-col>
          <el-col :span="14"><el-input size="mini" style="width: 60%" v-model="updateSkuPriceVal" onkeyup="this.value=this.value.replace(/[^\d.]/g, '').replace(/^\.{1,}/g,'').replace(/^0{2,}/g,'').match(/^\d{1,9}(\.?\d{0,2})/g);"></el-input><span>MYR</span></el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="updateSkuPriceVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateSkuPrice">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog :close-on-click-modal="false"   title="修改促销时间" :visible.sync="updateSkuTimeVisible" width="500px">
      <div style="margin: 10px 20px 0 20px;">
        <el-date-picker
                size="small"
                v-model="updateSkuTimeVal"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                :picker-options="skuTimeOption">
        </el-date-picker>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small"  @click="updateSkuTimeVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="updateSkuPromTime">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script type="text/ecmascript-6">
import Breadcrumb from '@/components/common/Breadcrumb';
import {getShopByPlatCode, publicUploadImg} from '@/api/product/common';
import {uploadImg, saveAndMoveToready, getLazadaEdit} from '@/api/product/lazada';
import {getPlatTypeTree, getPlatTypeName} from '@/api/plat/platType';
import TreeSelect from '@/components/common/treeSelect';
import {loadDataMap} from '@/api/tree/tree'
import draggable from 'vuedraggable';
import CKEditor4 from '@/components/common/CKEditor'
import {getImgInfo} from '@/utils/jn'
import {listType, getType, delType, addType, updateType} from "@/api/system/dict/type";
import {listData, getData, delData, addData, updateData} from "@/api/system/dict/data";

export default {
  name: "editProduct",
  components: {TreeSelect, Breadcrumb, CKEditor4, draggable},
  data() {
    var validateNum = (rule, value, callback) => {
      var reg = new RegExp(/^(([0-9]+[\.]?[0-9]+)|[1-9])$/);
      if (!reg.test(value)) {
        callback(new Error('请输入正确的数值'));
      }
      callback();
    };
    return {
      imgUrl: '../../../assets/images/addImg.jpg',
      visible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            picker.$emit('pick', new Date());
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24);
            picker.$emit('pick', date);
          }
        }, {
          text: '一周前',
          onClick(picker) {
            const date = new Date();
            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', date);
          }
        }]
      },
      claimList: [],//店铺集合
      cascaderName: null, //级联全路径名字
      lazadaOptions: [],
      lazadaDialogVisible: false, //lazada类目弹框
      bzxxDialogVisible: false, //设置变种信息弹框
      platType: null,//类目值
      options: [],
      treeList: [],
      quaTypeList: [],
      taxList: [],
      //变种信息属性
      bzxx: {
        input: '',
        tableData: [{
          skuno: '',
          pId: '',
          colorName: '',
          size: '',
          invent: '',
          price: '',
          promPrice: '',
          properName: '',
          startTime: '',
          stopTime: ''
        }]
      },
      bzxxRules:{
        skuno:[{ required: true, message: '请输入SKU', trigger: 'blur' }],
        invent:[{ required: true, message: '请输入库存', trigger: 'blur' }],
        price:[{ required: true, message: '请输入价格', trigger: 'blur' }]
      },
      material: [],
      pattern: [],
      warrantyPeriod: [],
      warrantyPolicy: '',
      deliveryOptionExpress: [],
      fa_create_year: [],
      fa_season: [],
      deliveryOptionEconomy: [],
      DangerousGoods: [],
      ProductDescription: '',
      spanArr: [],
      zdList: ['印度尼西亚', '菲律宾', '新加坡', '泰国'],
      urlSize:0,
      firstForm: {
        proSize: '',
        proWeight: '',
        proBrarcode: '',
        proRemark: '',
        typeNo: null,//本平台分类
        shopId: null,
        urls: [],//动态添加的URL
        shopType: null,
        fbzd: [],//发布站点
        proTitle: null,//产品标题
        maProTitle: null,//产品标题——马来语
        brand: null,//品牌
        model: null,//型号
        quaType: [],//质保类型
        tax: null,//税
        packWeight: null,//包装重量
        packLong: null,//包装体积--长
        packWide: null,//包装体积--宽
        packHigh: null,//包装体积--高
        packContent: '',//包装内容
        c_checkList: [],
        s_checkList: [],
        detail: null,
        simDesc: null,
        playUrl: null,
        lazadaSkus: [],
        lSite: '',
        mainPic: null
      },
      urlSize: 0,
      isIndeterminate: true,
      checkAll: false,
      rules: {
        shopId: [{required: true, message: '请选择店铺', trigger: 'change'}],
        shopType: [{required: true, message: '请选择分类', trigger: 'blur'}],
        proTitle: [{required: true, message: '请输入产品标题', trigger: 'blur'}],
        maProTitle: [{required: true, message: '请输入产品标题', trigger: 'blur'}],
        tax: [{required: true, message: '请选择缴税类别', trigger: 'change'}],
        packWeight: [
          {required: true, message: '请输入包装重量', trigger: 'blur'},
          {validator: validateNum, trigger: 'blur'}
        ],
        packLong: [
          {required: true, message: '请输入包装长度', trigger: 'blur'},
          {validator: validateNum, trigger: 'blur'}
        ],
        packWide: [
          {required: true, message: '请输入包装宽度', trigger: 'blur'},
          {validator: validateNum, trigger: 'blur'}
        ],
        packHigh: [
          {required: true, message: '请输入包装高度', trigger: 'blur'},
          {validator: validateNum, trigger: 'blur'}
        ],
        packContent: [{required: true, message: '请输入包装内容', trigger: 'blur'}],
        c_checkList: [{type: 'array', required: true, message: '请选择颜色种类', trigger: 'change'}]
      },
      colorList: [],
      sizeList: [],
      colorFilteField: null,
      sizeFilteField: null,
      otherColor: null,
      otherSize: null,
      props: {
        value: 'id',
        children: 'children',
        label: 'name'
      },
      chooseType: false,//选择分类
      options2: [],
      editorConfig_1: {
        toolbar: [
          ['Source', 'Maximize'],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
          ['Outdent', 'Indent'],
          ['Subscript', 'Superscript'],
          ["NumberedList", "BulletedList"],
          ['HorizontalRule', 'RemoveFormat'],
          ['Preview'],
          ["Undo", "Redo"],
          ["Styles", "Font", "FontSize", "Format"],
          ['Paste', 'PasteText', 'PasteFromWord', "Table"],
          ["Link", "Unlink"]
        ]
      },
      editorConfig_2: {
        toolbar: [
          ['Source', 'Maximize'],
          ["Bold", "Italic", "Underline", "Strike"],
          ["TextColor", "BGColor"],
          ['JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock'],
          ['Outdent', 'Indent'],
          ['Subscript', 'Superscript'],
          ["NumberedList", "BulletedList"],
          ['HorizontalRule', 'RemoveFormat'],
          ['Preview'],
          ["Undo", "Redo"],
          ["Styles", "Font", "FontSize", "Format"],
          ['Paste', 'PasteText', 'PasteFromWord', "Table"],
          ["Link", "Unlink"]
        ]
      },
      picList: [],
      definePicList: [],
      picPicList: [],
      uploadDis: true,
      expendBtnText:'展开',
      creatSkuRuleVisible:false,
      skuRuleForm:{
        prefix:'',//生成sku前缀
        suffix:''//生成sku后缀
      },
      updateSkuInventVisible:false,
      updateSkuPriceVisible:false,
      updateSkuTimeVisible:false,
      priceText:'价格',
      skuInventRadio:1,//1 直接修改库存量   2 根据现有库存量增减
      updateSkuInventNum_1:0 ,//库存量修改值
      updateSkuInventNum_2:0 ,//库存量修改值
      updateSkuPriceVal:null,//价格批量修改值
      updateSkuTimeVal:null,//促销时间批量修改值
      currentStartTime:null,
      skuTimeOption : {disabledDate:(time)=> {return time.getTime() < Date.now()-1 * 24 * 3600 * 1000}},
      tabSkuEndTimeOption : {disabledDate:(time)=> {return time.getTime() < this.currentStartTime.getTime();}},
      waitToEditColorFamily:[],//待修改Color Family集合
      colorAndSizeGroup:[],//color和size组合，用于生成变种信息和变种信息列表
    }

  },
  computed: {},
  created() {
    let that = this;
    //获取当前用户
    var userName = this.$store.state.user.name;
    //获取店铺集合
    getShopByPlatCode('03').then((res) => {
      that.claimList = res.data;
    });
    that.loadNodeData();
    that.loadLazadaData();
    //查询从采集箱页面跳转过来的数据
    that.getLazadaEditData();
  },
  methods: {
    changeCheckColor(val) {
      this.createColorAndSizeGroup();
      console.log(this.colorAndSizeGroup);
    },
    changeCheckSize(val) {
      this.createColorAndSizeGroup();
      console.log(this.colorAndSizeGroup);
    },
    createColorAndSizeGroup(){
      this.colorAndSizeGroup = [];
      let c_arr = this.firstForm.c_checkList;
      let s_arr = this.firstForm.s_checkList;
      if(c_arr.length >0 && s_arr.length > 0){
        c_arr.forEach(c => {
          s_arr.forEach(s => {
            let map = {'color':c,'size':s,'picList':[]};
            this.colorAndSizeGroup.push(map);
          })
        });
      }
      if(c_arr.length > 0 && s_arr.length == 0){
        c_arr.forEach(c => {
          let map = {'color':c,'picList':[]};
          this.colorAndSizeGroup.push(map);
        })
      }
      if(s_arr.length > 0 && c_arr.length == 0){
        s_arr.forEach(s => {
          let map = {'size':s,'picList':[]};
          this.colorAndSizeGroup.push(map);
        })
      }
    },
    asPicToAllSub: function (row) {
      alert(111);
    },

    addCollPic: function (row) {
      alert(111);
    },
    //批量加水印
    batchAddWater: function (row) {
      alert(111);
    },
    //修改图片尺寸
    updatePicSize: function (row) {
      alert(111);
    },

    //导出全部图片
    exportAllPic: function (row) {
      alert(111);
    },
    //删除变种图片
    removeBzImg(img,imgList){
      let index = imgList.indexOf(img);
      imgList.splice(index,1);
    },
    //变种信息表格设置
    setAttr: function (row) {
      this.bzxxDialogVisible = true;
    },
    moveAttr: function (row, index) {
      this.bzxx.tableData.splice(index, 1);
    },
    addUrl: function () {
        let cope = {url:''};
        this.firstForm.urls.push(cope);
        this.urlSize = this.firstForm.urls.length;
    },
    goUrl: function (val) {
      window.open(val, '_blank').location;
    },
    deleteUrl: function (val) {
        this.firstForm.urls.splice(val,1);
        this.urlSize = this.editForm.urls.length;
    },
    explanRow: function (val) {
      var flag = $("." + val).is(":hidden");
      if (flag) {
        $("#row_bt").html(`收起<i class="el-icon-caret-top"></i>`);
        $("." + val).show();
      } else {
        $("#row_bt").html(`展开<i class="el-icon-caret-bottom"></i>`);
        $("." + val).hide();
      }
    },
    handleCheckAllChange: function (val) {
      this.firstForm.fbzd = val ? this.zdList : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      var checkedCount = value.length;
      this.checkAll = checkedCount === this.zdList.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.zdList.length;
    },
    //锚点
    sideBarTool: function () {
      var aNav = $('#LoutiNav li');
      var aDiv = $('#main .t_plane');
      $(window).scroll(function () {
        var winH = $(window).height();//可视窗口高度
        var iTop = $(window).scrollTop();//鼠标滚动的距离
        aDiv.each(function () {
          if (winH + iTop - $(this).offset().top > winH - 200) {
            aNav.removeClass('active');
            aNav.eq($(this).index()).addClass('active');
          }
        })
      });
      //点击回到对应面板
      aNav.click(function () {
        var t = aDiv.eq($(this).index()).offset().top - 199;
        $('body,html').animate({"scrollTop": t}, 500);
        $(this).addClass('active').siblings().removeClass('active');
      });
    },
    //颜色过滤字段改变
    c_fieldChange: function (val) {
      $("#col_List .el-checkbox").each(function () {
        if ($(this).find(".el-checkbox__label").text().indexOf(val) != -1) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    },
    //尺寸字段过滤
    s_fieldChange: function (val) {
      $("#siz_List .el-checkbox").each(function () {
        if ($(this).find(".el-checkbox__label").text().indexOf(val) != -1) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    },

    addColor: function () {
      let _self = this;
      if (_self.otherColor == null || _self.otherColor == "") {
        return false;
      }
      let sameColorArr = _self.colorList.filter(item => {
        return item.dictLabel == _self.otherColor;
      });
      if(sameColorArr.length > 0){//如果添加的颜色已存在，则直接选中
          this.firstForm.c_checkList.push(sameColorArr[0].dictLabel);
          this._self.otherColor = null;
      }else{ //添加的颜色不存在，加入颜色集合中
        let colorObj = {'dictCode': _self.otherColor, 'dictLabel': _self.otherColor,'isManualAdd':true,'isEdit':false};
        _self.colorList.push(colorObj);
        this.firstForm.c_checkList.push(_self.otherColor);
      }
      _self.otherColor = null;
    },
    addSize: function () {
      var _self = this;
      if (_self.otherSize == null || _self.otherSize == "") {
        return false;
      }
      if (_self.sizeList.indexOf(_self.otherSize) > -1) {
        _self.$confirm('您要添加的尺码已存在，确定要添加吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          // _self.sizeList.push(_self.otherSize);
          let maxVal = Math.max.apply(Math, _self.sizeList.map(item => {
            return item.dictCode
          }));
          let param = {'dictCode': maxVal + 1, 'dictLabel': _self.otherSize};
          _self.sizeList.push(param);
          _self.$message({
            type: 'success',
            message: '添加成功!'
          });
          _self.otherSize = null;
        }).catch(() => {
          _self.$message({
            type: 'info',
            message: '已取消'
          });
        });
      } else {
        //获取字典ID的最大值
        let maxVal = Math.max.apply(Math, _self.sizeList.map(item => {
          return item.dictCode
        }));
        let param = {'dictCode': maxVal + 1, 'dictLabel': _self.otherSize};
        _self.sizeList.push(param);
        _self.$message({
          type: 'success',
          message: '添加成功!'
        });
        _self.otherSize = null;
      }
    },
    openDialogChooseType: function () {
      this.chooseType = true;
    },
    submitChooseType: function () {
      this.chooseType = false;
    },

    //自定义缩略图删除回调删除
    zdyImgRemove(file, fileList,index){
      setTimeout(function () {
        let id = 'default_img_'+index;
        document.getElementById(id).style.display='block';
      },100);

    },
    zdyImgChange(file, fileList,index){
      getImgInfo(file.url).then(res =>{
        let imgItem = $('.upload_img_'+index).find('ul li img');
        if(parseInt(res.width) > parseInt(res.height)){
            imgItem.addClass('use-width');
        }else{
            imgItem.addClass('use-height');
        }
      });
      let id = 'default_img_'+index;
      document.getElementById(id).style.display='none';
    },
    //自定义缩略图上传成功回调函数
    zdyImgSuccess(file, fileList,index){
      let id = 'default_img_'+index;
      document.getElementById(id).style.display='none';
    },
    //自定义缩略图-覆盖默认上传行为
    uploadZdyImg(data){
      let that = this;
      let formData = new FormData();
      formData.append("imageFile", data.file);
      uploadImg(formData).then(res => {
        if(res.code == 200){
          that.msgSuccess("图片上传成功");
        }
      }).catch(err => {});
    },
    handlePreview(file) {
      console.log(file);
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    handleExceed(files, fileList) {
      this.$message.warning(`变种图片最多能上传8张，本次选择了 ${files.length} 张图片，共选择了 ${files.length + fileList.length} 张图片`);
    },
    requertUpload(data,picList) {
      var that = this;
      let formData = new FormData();
      formData.append("imageFile", data.file);
      uploadImg(formData).then(res => {
        if (res.code == 200) {
          that.msgSuccess("图片上传成功");
          let url = res.data.img;
          getImgInfo(url).then(responce =>{
            if(parseInt(responce.width) > parseInt(responce.height)){
              res.data.class = 'use-width';
            }else{
              res.data.class = 'use-height';
            }
            picList.push(res.data);
          });
        }
      }).catch(err => {
      });
    },
    uploadDefinePic(data) {
      let formData = new FormData();
      formData.append('picType', '02');
      this.uploadByPicType(formData, data)
    },
    //移除照片
    deletePic(index) {
      let that = this;
      that.picPicList.splice(index, 1);
      this.uploadDis = true
    },

    requertUploadSize(data) {
      let formData = new FormData();
      formData.append('picType', '02');
      this.uploadByPicType(formData, data)
    },
    //上传图片时,区分不同的图片类型参数
    uploadByPicType(formData, data) {
      //文件
      formData.append("imageFile", data.file);
      publicUploadImg(formData).then(res => {
        if (res.code == 200) {
          this.msgSuccess("图片上传成功");
          if (formData.get("picType") == "02") {
            this.picPicList.push(res.data);
            this.uploadDis = false;
          } else {
            let url = res.data.img;
            this.definePicList.push(res.data);
          }
        }
      }).catch(err => {
      });
    },
    start(e) {
      // alert(e)
    },
    end(e) {
      // alert(e)
    },

    //选择分类
    getPlatTypeTree() {
      this.lazadaDialogVisible = true;
      let params = {
        platNo: '03'
      };
      if(sessionStorage.getItem("lazadaOptions") != null){
        let lazadaOptions = JSON.parse(sessionStorage.getItem("lazadaOptions"));
        lazadaOptions.forEach(items => {
          if (items.children != '' && items.children != 'undefined' && items.children.length > 0) {
            this.getTypeList(items.children);
          } else {
            items.children = undefined;
          }
        });
        this.getTypeList(lazadaOptions);

      }else{
        getPlatTypeTree(params).then((res) => {
          sessionStorage.setItem("lazadaOptions",JSON.stringify(res.data));
          this.lazadaOptions = res.data;
          res.data.forEach(items => {
            if (items.children != '' && items.children != 'undefined' && items.children.length > 0) {
              this.getTypeList(items.children);
            } else {
              items.children = undefined;
            }
          });
          this.getTypeList(this.lazadaOptions);
        })
      }

    },
    //递归把空数组变成undefined,不然会存在空级联的BUG
    getTypeList(lazadaOptions) {
      lazadaOptions.forEach(items => {
        if (items.children != '' && items.children != 'undefined' && items.children.length > 0) {
          this.getTypeList(items.children);
        } else {
          items.children = '';
        }
      });
    },

    //lazada平台类目选择确定按钮
    lazadaDialogSubmit() {
      let arrValId = this.getArrValId(this.platType);
      //根据ID获取属性名
      this.getLazadaAttrName(arrValId);
      this.lazadaDialogVisible = false;
      let join = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels.join(" > ");
      this.cascaderName = join;
    },

    bzxxDialogSubmit() {
      this.bzxxDialogVisible = false;
    },

    //获取级联中文
    handleChange() {
      //使用 > 全路径进行分割
      // let join = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels.join(" > ");
      // this.cascaderName=join;
    },

    //把数组分割成字符串并取最后一个
    getArrValId(platType) {
      //以逗号分割数组,转成字符串
      let platTypeStr = platType.join(",");
      //取出最后一个逗号后面的ID
      let attrId = platTypeStr.substring(platTypeStr.lastIndexOf(",") + 1);
      return attrId;
    },

    //根据lazada平台ID获取Name
    getLazadaAttrName(id) {
      getPlatTypeName(id).then((res) => {
        this.firstForm.shopType = res.data.catName;

      })
    },

    loadNodeData() {
      let that = this;
      loadDataMap().then((res) => {
        that.treeList = that.optionData(res.data);
        setTimeout(function () {
          that.$refs.childSelTree.initHandle();
        }, 100);
      })
    },
    loadLazadaData() {
      //质保类型
      if(sessionStorage.getItem("lazada_qa_type")){
        this.quaTypeList = JSON.parse(sessionStorage.getItem("lazada_qa_type"));
      }else{
        this.getDicts("lazada_qa_type").then(response => {
          sessionStorage.setItem("lazada_qa_type",JSON.stringify(response.data));
          this.quaTypeList = response.data;
        });
      }
      //税
      this.getDicts("lazada_tax").then(response => {
        this.taxList = response.data;
      });

      //颜色
      this.getDicts("lazada_color").then(response => {
        this.colorList = response.data;
      });


      //尺寸
      this.getDicts("lazada_size").then(response => {
        this.sizeList = response.data;
      });

      this.getDicts("lazada_material").then(response => {
        this.material = response.data;
      });

      this.getDicts("lazada_pattern").then(response => {
        this.pattern = response.data;
      });

      this.getDicts("lazada_warranty").then(response => {
        this.warrantyPeriod = response.data;
      });

      this.getDicts("lazada_Express").then(response => {
        this.deliveryOptionExpress = response.data;
      });

      this.getDicts("lazada_fa_create_year").then(response => {
        this.fa_create_year = response.data;
      });

      this.getDicts("lazada_season").then(response => {
        this.fa_season = response.data;
      });

      this.getDicts("lazada_DeliveryOptionEconomy").then(response => {
        this.deliveryOptionEconomy = response.data;
      });

      this.getDicts("lazada_DangerousGoods").then(response => {
        this.DangerousGoods = response.data;
      });
    },

    //展开或收起关键属性
    showMoreProp(){
      let _dom = document.querySelector('.import-prop');
      _dom.classList.toggle('heigt-90');
      let h = document.querySelector('.heigt-90');
      if(h){
        this.expendBtnText = '展开'
      }else{
        this.expendBtnText = '收起'
      }
    },

    handleNodeClick(data, Node) {
      // 如果是顶级父节点
      if (Node.parent.level === 0) {
        // 不会触发事件
      } else {

      }
    },

    //一键生成变种信息SKU
    creatSkuBatch(){
      let prefix = this.skuRuleForm.prefix;
      let suffix = this.skuRuleForm.suffix;
      this.bzxx.tableData.forEach(row =>{
        row.skuno = prefix + '-'+row.properName + '-'+suffix;
      });
      this.creatSkuRuleVisible = false;
    },
    //批量修改库存
    updateSkuInvent(){
      if(this.skuInventRadio == 1){
        this.bzxx.tableData.forEach(row =>{
          row.invent = this.updateSkuInventNum_1;
        });
      }else if(this.skuInventRadio == 2){
        this.bzxx.tableData.forEach(row =>{
          row.invent = parseInt(row.invent) + parseInt(this.updateSkuInventNum_2)
        });
      }
      this.updateSkuInventVisible = false;
    },
    openPriceDialog(val){
      this.priceText = val;
      this.updateSkuPriceVisible = true;
    },
    updateSkuPrice(){
      if(this.priceText == '价格'){
        this.bzxx.tableData.forEach(row =>{
          row.price = this.updateSkuPriceVal;
        });
      }else if(this.priceText == '促销价'){
        this.bzxx.tableData.forEach(row =>{
          row.promPrice = this.updateSkuPriceVal;
        });
      }
      this.updateSkuPriceVal = null;
      this.priceText = null;
      this.updateSkuPriceVisible = false;
    },
    //一键修改促销时间
    updateSkuPromTime(){
      if(this.updateSkuTimeVal == null){
        return false;
      }
      this.bzxx.tableData.forEach(row =>{
        row.startTime = this.updateSkuTimeVal[0];
        row.stopTime = this.updateSkuTimeVal[1];
      });
      this.updateSkuTimeVal = null;
      this.updateSkuTimeVisible = false;
    },
    clearNoNumAndFloat(val){
      var pattern = /-?[1-9]\d*/;
      if(! pattern.test(val)){
        this.updateSkuInventNum_2 = 0;
      }
    },
    setCurrentSku(startTime){
      this.currentStartTime = startTime;
    },
    //color family 编辑
    editColorName(item){
      this.waitToEditColorFamily.push(JSON.parse(JSON.stringify(item)));
      item.isEdit = true;
    },
    //color Family 保存编辑
    saveEditColorName(item){
      let editArr = this.waitToEditColorFamily.filter(color => { return color.distCode == item.distCode});

      this.firstForm.c_checkList.splice(this.firstForm.c_checkList.indexOf(editArr[0].dictLabel),1,item.dictLabel);//跟新选中集合中的数据
      this.waitToEditColorFamily.splice(this.waitToEditColorFamily.indexOf(editArr[0].dictLabel),1);
      item.isEdit = false;
    },
    //color family 取消编辑
    cancleEditColorName(item){
      let editArr = this.waitToEditColorFamily.filter(color => { return color.distCode == item.distCode});
      item.dictLabel = editArr[0].dictLabel;
      //移除取消编辑项
      this.waitToEditColorFamily.splice(this.waitToEditColorFamily.indexOf(editArr[0].dictLabel),1);
      item.isEdit = false;
    },
    createTreeData(data) {
      let treedata = data.filter(father => {
        if (father['pTypeNo'] == "" || father['pTypeNo'] == null) {
          father['pTypeNo'] = '0'
        }
        let childArr = data.filter(child => {
          return child['pTypeNo'] == father.id;
        });
        childArr.length > 0 ? father.children = childArr : '';
        return father['pTypeNo'] == '0';
      });
      return treedata;
    },

    /* 转树形数据 */
    optionData(data) {
      let cloneData = JSON.parse(JSON.stringify(data))      // 对源数据深度克隆
      return cloneData.filter(father => {                      // 循环所有项，并添加children属性
        let branchArr = cloneData.filter(child => father.id == child.parentId);       // 返回每一项的子级数组
        branchArr.length > 0 ? father.children = branchArr : ''   //给父级添加一个children属性，并赋值
        return father.parentId == 0;      //返回第一层
      });
    },

    //获取本平台树的ID
    getTreeNodeId(val) {
      this.firstForm.typeNo = val;
    },
    getSpanArr(data) {
      if (data != null && data != 'undifine') {
        for (var i = 0; i < data.length; i++) {
          if (i === 0) {
            this.spanArr.push(1);
            this.pos = 0
          } else {
            // 判断当前元素与上一个元素是否相同,因合并第一个所以[0]
            if (data[i]["id"] === data[i - 1]["id"]) {
              this.spanArr[this.pos] += 1;
              this.spanArr.push(0);
            } else {
              this.spanArr.push(1);
              this.pos = i;
            }
          }
        }
      } else {
        this.$message({
          type: 'info',
          message: '暂无数据!'
        });
      }
    },

    saveEditPro() {
      alert('11111');
    },


    //保存并移入待发布
    submitForm() {
      //必填校验
      this.bzxx.tableData[0].startTime = this.firstForm.startTime1;
      this.bzxx.tableData[0].stopTime = this.firstForm.stopTime1;
      this.firstForm.lazadaSkus = this.bzxx.tableData;
      if (this.firstForm.fbzd != null && this.firstForm.fbzd != '') {
        this.firstForm.lSite = this.firstForm.fbzd.join(" , ");
      }
      this.$refs["firstForm"].validate(valid => {
        if(valid){
          saveAndMoveToready(this.firstForm).then((res) => {
            if (res.code == 200) {
              this.msgSuccess("产品创建成功");
              this.$refs["firstForm"].resetFields();
            }
          }).catch(err => {
          });
        }else{
          this.$message.warning("产品信息填写不完整！");
        }

      })
    },


    getLazadaEditData() {
      getLazadaEdit(this.$route.query.pId).then((res) => {
        console.log(res.data);
        let sCpLazada = res.data.sCpLazada;
        if(sCpLazada.dataUrl){
          sCpLazada.dataUrl.split(',').forEach(item => {
            var map ={'url':item}
          this.firstForm.urls.push(map);
          });
        }
        if(this.firstForm.urls.length == 0){
          this.firstForm.urls.push({'url':''});
        }
        if(sCpLazada.typeNo != null && sCpLazada.typeNo != ''){//平台分类
          this.firstForm.typeNo = parseInt(sCpLazada.typeNo);
        }
        this.firstForm.shopId = sCpLazada.shopId;//店铺名称
        this.firstForm.brand = sCpLazada.brand ;
        this.firstForm.proTitle = sCpLazada.proTitle;
        this.firstForm.maProTitle = sCpLazada.maProTitle;
        this.firstForm.model = sCpLazada.model;
        this.firstForm.quaType = sCpLazada.quaType;
        this.firstForm.tax = sCpLazada.tax;
        this.firstForm.packWeight = sCpLazada.packWeight;
        this.firstForm.packLong = sCpLazada.packLong;
        this.firstForm.packWide = sCpLazada.packWide;
        this.firstForm.packHigh = sCpLazada.packHigh;
        this.firstForm.packContent = sCpLazada.packContent;
        this.firstForm.detail = sCpLazada.detail;
        this.firstForm.simDesc = sCpLazada.simDesc;
        this.firstForm.playUrl = sCpLazada.playUrl;
        this.bzxx.tableData = sCpLazada.lazadaSkus;

        let imgPic = {
          checked: false,
          height: "800",
          id: null,
          img: res.data.mainPic,
          picType: "02",
          width: "800"
        };
        this.picPicList.push(imgPic);
        this.uploadDis = false;


      })
    }


  },
  mounted() {
    this.getSpanArr(this.bzxx.tableData);
    this.sideBarTool();
  }
}
</script>

<style scoped>
#url_ly .el-input-group__append, #url_ly .el-input-group__prepend {
  padding: 0 10px !important;
  color: #000000;
}

#url_ly .el-input-group__append:hover {
  color: #4934b2;
}

.lazada_edit .url_a {
  color: #4934b2;
  cursor: pointer;
  font-size: 18px;
}

.lazada_edit i {
  font-style: normal;
}

ul, li, dl, ol {
  list-style: none;
}

#LoutiNav {
  position: fixed;
  top: 150px;
  right: 50px;
  display: none;
}

#LoutiNav li {
  width: 80px;
  height: 30px;
  line-height: 30px;
  text-align: left;
  cursor: pointer;
  position: relative;
}
#LoutiNav li svg{
  position: absolute;
  left: -23px;
  top: 7px;
  display: none;
}
#LoutiNav .active {
  color: red;
}
#LoutiNav .active svg{
  display: block;
}
</style>


